/******************************************************************************************
 *  Number Filter
 *******************************************************************************************
 *
 * Only positive, non-exponent, numbers are handled. These are used to represent counts.
 *
 * For a subset of locales, eliminate the group separator for 1,000.
 * This filter will check for this case before calling the built-in number filter.
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.numberFormatter', []).filter(
    'numberFormatter',
    /* @ngInject */
    function($filter, _, locale) {
      return function(number) {
        if (!_.isNumber(number) && _.isNaN(Number.parseFloat(number))) {
          // provided value isn't a number, so return it as the string to display
          return number;
        }
        // In countries with the comma separator, the number ‘one thousand’ is often displayed as
        // 1000 rather than 1,000; with separations only occurring for numbers with >=5 digits.
        const noThousandsSep = _.includes(
          ['da_DK', 'nl_NL', 'tr_TR', 'ru_RU'],
          locale.getActiveLocaleCode()
        );

        if (noThousandsSep && isFinite(number)) {
          var numStr = String(number);
          if (numStr.length < 5) {
            return numStr;
          }
        }

        return $filter('number')(number);
      };
    }
  );
})();
